<script setup>
import { ref, watch, toRefs } from 'vue';
import Goods from './Cards/Goods.vue';
import Order from './Cards/Order.vue';
import ReverseOrder from './Cards/ReverseOrder.vue';
import OrderList from './Cards/OrderList.vue';
import RefundIntention from './Cards/RefundIntention.vue';
import { CardType } from './utils';

const componentMap = {
  [CardType.GOODS]: Goods,
  [CardType.ORDER]: Order,
  [CardType.REVERSE_ORDER]: ReverseOrder,
  [CardType.ORDER_LIST]: OrderList,
  [CardType.ACTION]: OrderList,
  [CardType.REFUND_INTENTION]: RefundIntention,
};

const props = defineProps({
  type: {
    type: String,
    required: true,
  },
  message: {
    type: Object,
    required: true,
  },
});

const resolvedComponent = ref(null);

// 从props中提取 type 属性
const { type } = toRefs(props);

// 监听name变化
watch(
  type,
  async newType => {
    if (!newType) return;
    resolvedComponent.value = componentMap[newType];
  },
  { immediate: true }
);
</script>

<template>
  <component :is="resolvedComponent" v-if="resolvedComponent" v-bind="$props" />
  <span v-else class="icon-placeholder" />
</template>

<style scoped>
.icon-placeholder {
  display: inline-block;
  width: v-bind(width + 'px');
  height: v-bind(height + 'px');
}
</style>
